import React from 'react';
import { useAuth } from '../context/AuthContext';
import { AppHeader } from './AppHeader';
import { Watermark } from './Watermark';
import { Navigate } from 'react-router-dom';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="layout">
      <AppHeader showUserInfo={true} />
      <main className="layout-main">
        {children}
      </main>
      <Watermark />
    </div>
  );
};